import { LockOpen } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { COLORS, primaryContainedButtonSx } from "assets";
import useTranslation from "hooks/useTranslation";
import { requestBreakGlass } from "utils/breakGlass";

/**
 * Super-admin empty state: explain session unlock before home data appears.
 */
export default function SuperBreakGlassPanel() {
  const t = useTranslation();

  return (
    <Box
      role="region"
      aria-label={t["Break-glass access"] || "Break-glass access"}
      sx={{
        width: "100%",
        border: `1px solid ${COLORS.surface.border}`,
        borderRadius: `${COLORS.radius.lg}px`,
        bgcolor: COLORS.surface.card,
        boxShadow: COLORS.shadow.card,
        px: { xs: 2.5, sm: 3.5 },
        py: { xs: 3, sm: 4 },
        mb: 2,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: "space-between",
        gap: 2.5
      }}
    >
      <Box minWidth={0} flex={1}>
        <Typography sx={{ color: COLORS.surface.primaryText, fontWeight: 700, fontSize: 17, mb: 0.75 }}>
          {t["Unlock a home to view the dashboard"] || "Unlock a home to view the dashboard"}
        </Typography>
        <Typography sx={{ color: COLORS.surface.secondaryText, fontSize: 14, lineHeight: 1.55, maxWidth: 640 }}>
          {t["Super break-glass dashboard hint"] ||
            "As a super admin, site data stays locked until you unlock one home for this browser session (break-glass). Pick a site above or use Unlock a site, enter a short reason, then charts and events load. Access lasts until you log out and is audited."}
        </Typography>
      </Box>
      <Button
        variant="contained"
        startIcon={<LockOpen />}
        onClick={() => requestBreakGlass()}
        sx={{
          ...primaryContainedButtonSx,
          flexShrink: 0,
          alignSelf: { xs: "stretch", sm: "center" },
          px: 2.5,
          height: 44,
          textTransform: "none",
          fontWeight: 600
        }}
      >
        {t["Unlock a site"] || "Unlock a site"}
      </Button>
    </Box>
  );
}
